import image1 from '@/main/assets/images/homepage/asset@3x.png';
import image2 from '@/main/assets/images/homepage/xnuup_03_Van_large.jpg';

import * as S from './styles';
import TextImage from '../components/textImage/textImage';
import { getTranslateByKey } from '@/main/services/utils';

function HomepagePrivacyPolicy() {
  return (
    <S.Container>
      <S.FirstSection $backgroundImage={image1}>
        <TextImage
          backgroundImage={image2}
          title={getTranslateByKey('information.privacyPolicy')}
          description=""
          positionImage="right"
          idImage="id-homepage-privacyPolicy-image-2"
          imageProps={{
            clipBorderImage: 'bottom',
            width: '540px',
            height: '609px'
          }}
        />
      </S.FirstSection>
      <S.TextContainer>
        {getTranslateByKey('information.homepagePrivacyPolicy1')}
        <br />
        <br />
        <br />
        <p style={{ fontWeight: '700 ' }}>
          {getTranslateByKey(
            'information.homepagePrivacyPolicy2'
          ).toUpperCase()}
        </p>
        {getTranslateByKey('information.homepagePrivacyPolicy3')}
        <br />
        <br />
        <br />
        <p style={{ fontWeight: '700' }}>
          {getTranslateByKey(
            'information.homepagePrivacyPolicy4'
          ).toUpperCase()}
        </p>
        {getTranslateByKey('information.homepagePrivacyPolicy5')}

        <ol type="a">
          <li>{getTranslateByKey('information.homepagePrivacyPolicy6')}</li>
          <li>{getTranslateByKey('information.homepagePrivacyPolicy7')}</li>
          <li>{getTranslateByKey('information.homepagePrivacyPolicy8')}</li>
          <li>{getTranslateByKey('information.homepagePrivacyPolicy9')}</li>
        </ol>

        {getTranslateByKey('information.homepagePrivacyPolicy10')}
        <ol type="a">
          <li>{getTranslateByKey('information.homepagePrivacyPolicy11')}</li>
          <li>{getTranslateByKey('information.homepagePrivacyPolicy12')}</li>
        </ol>

        {getTranslateByKey('information.homepagePrivacyPolicy13')}
        <br />
        <br />
        <br />
        <p style={{ fontWeight: '700' }}>
          {getTranslateByKey(
            'information.homepagePrivacyPolicy14'
          ).toUpperCase()}
        </p>
        {getTranslateByKey('information.homepagePrivacyPolicy15')}
      </S.TextContainer>
    </S.Container>
  );
}

export default HomepagePrivacyPolicy;
